module.exports = __webpack_public_path__ + "static/media/icon2.e06e0a68.svg";